import React, { useState, useEffect } from "react"
import {
  formContainer,
  formContainerDark,
  container,
  center,
  buttonContainer,
  buttonIcon,
  clicked,
} from "./contact.module.scss"
import { themeState } from "../state"
import { useRecoilValue } from "recoil"

const Contact = () => {
  const [buttonClickedState, setButtonClickedState] = useState(false)
  const theme = useRecoilValue(themeState)

  useEffect(() => {
    let timer
    if (buttonClickedState) {
      timer = setTimeout(() => {
        setButtonClickedState(false)
      }, 4000)
    }

    return () => {
      clearTimeout(timer)
    }
  }, [buttonClickedState])

  const setButtonSlideBg = e => {
    setButtonClickedState(true)
  }

  return (
    <section className={center}>
      <article className={container}>
        <h2>Get In Touch</h2>
        <form
          className={theme ? formContainerDark : formContainer}
          action="https://formspree.io/f/xaylzbqy"
          method="POST"
        >
          <input type="text" placeholder="Name" name="name" />
          <input type="email" placeholder="Email" name="email" />
          <textarea placeholder="Message" name="message" row="10" />
          <div className={buttonContainer}>
            <button
              type="submit"
              onClick={setButtonSlideBg}
              className={buttonClickedState ? clicked : null}
            >
              <span></span>
              <span>{buttonClickedState ? `Sent` : "Send"}</span>
            </button>
          </div>
        </form>
      </article>
    </section>
  )
}

export default Contact
